import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGameStore } from '@/store/gameStore'
import { DIVISIONS, PLAYER_CLUB_ID } from '@/config/leagueConfig'
import { CampusHero } from '../campus/CampusHero'
import { VersusBanner } from '../broadcast'

// Dashboard hero. With a pending league fixture it becomes a broadcast
// matchup teaser (click -> /competitions); otherwise it falls back to the
// campus hero (click -> /club) so the early game is unchanged.
export function NextMatchHero() {
  const navigate = useNavigate()
  const league = useGameStore(s => s.league)
  const [bgOk, setBgOk] = useState(true)

  const nextFixture = league?.fixtures.find(
    f => !f.result && (f.homeId === PLAYER_CLUB_ID || f.awayId === PLAYER_CLUB_ID)
  )

  if (!league || !nextFixture) {
    return (
      <div onClick={() => navigate('/club')} style={{ cursor: 'pointer' }} title="Ver Mi Club">
        <CampusHero compact />
      </div>
    )
  }

  const division = DIVISIONS[league.division]
  const clubName = (clubId: string) =>
    clubId === PLAYER_CLUB_ID ? 'Mi Club' : league.clubs.find(c => c.id === clubId)?.name ?? clubId

  return (
    <div
      onClick={() => navigate('/competitions')}
      title="Ir a Competiciones"
      style={{
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 'var(--glass-radius)',
        overflow: 'hidden',
        border: '1px solid var(--glass-border)',
        boxShadow: 'var(--shadow-md)',
        background: 'var(--midnight-blue)',
      }}
    >
      {bgOk && (
        <img
          src="/assets/broadcast/arena-dusk.webp"
          alt=""
          onError={() => setBgOk(false)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
      <div style={{ position: 'absolute', inset: 0, background: 'var(--broadcast-stage)' }} />

      <div style={{ position: 'relative', padding: '1.1rem 1.25rem 1.25rem' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.75rem',
          }}
        >
          <span className="chip-angled tone-gold">Jornada {nextFixture.matchday}</span>
          <span
            style={{
              fontFamily: 'var(--font-titles)',
              fontSize: '0.6875rem',
              fontWeight: 700,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: 'var(--chrome-silver)',
            }}
          >
            {division.name} · Próximo partido
          </span>
        </div>
        <VersusBanner
          home={{ name: clubName(nextFixture.homeId), isPlayer: nextFixture.homeId === PLAYER_CLUB_ID }}
          away={{ name: clubName(nextFixture.awayId), isPlayer: nextFixture.awayId === PLAYER_CLUB_ID }}
          tone="upcoming"
        />
      </div>
    </div>
  )
}
